module.exports = __webpack_public_path__ + "img/CaaS.e3138d3f.png";